<template>
  <div class="container">
    <Title-b :title="$t('Side.DeclarantInfo')" />
    <div class="goods" @click="add()">{{ $t("Declarant.addDeclarant") }}</div>
    <i-table :columns="columns" border :data="tableData" align="center" id="Tbaleone"></i-table>
    <Page :total="AllCount" :current="pageNo" :page-size="pageSize" @on-change="onpage" show-total show-elevator/>

    <!-- 添加申报人 -->
    <r-mask :title="$t('Declarant.addDeclarant')" :isShowModal="showModal" @closeMask="closeEdit">
      <Form  :model="formItem" ref="formValidate" :label-width="90" :rules="ruleValidate">
        <Form-item :label="$t('Declarant.peoName')" prop="RName">
          <Input v-model="formItem.RName"></Input>
        </Form-item>
        <Form-item :label="$t('Declarant.peoPhone')" prop="Tel">
          <Input v-model="formItem.Tel"></Input>
        </Form-item>
        <Form-item :label="$t('Declarant.peoNumber')" prop="RIDNumber">
          <Input v-model="formItem.RIDNumber"></Input>
        </Form-item>
        <Form-item>
          <div class="goods" @click="addSave('formValidate')">
            {{ $t("Declarant.save") }}
          </div>
        </Form-item>
      </Form>
    </r-mask>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      showModal: false,
      formItem: {},
      ruleValidate: {
        RName: [
          {
            required: true,
            message: this.$t("Declarant.peoName") + this.$t("Declarant.isEmpty"),
            trigger: "blur",
          },
        ],
        Tel: [
          {
            required: true,
            message: this.$t("Declarant.peoPhone") + this.$t("Declarant.isEmpty"),
            trigger: "blur",
          },
        ],
        RIDNumber: [
          {
            required: true,
            message: this.$t("Declarant.peoNumber") + this.$t("Declarant.isEmpty"),
            trigger: "blur",
          },
        ],
      },
      pageNo:1,
      AllCount:0,
      pageSize:10,
    };
  },
  created() {
    this.getDeclarantList();
  },
  methods: {
    onpage(pageNo){
      this.pageNo = pageNo;
      // this.tableData = []
      this.getDeclarantList();
    },
    getDeclarantList() {
      let JsonData = {
        MemberId: localStorage.getItem("userID"),
        offset: (this.pageNo - 1) * this.pageSize, // 每页条数
        limit: this.pageSize,   // 第几页
      };
      this.$post("/QueryReciver", JsonData).then((res) => {
        if (res.data.State) {
          this.tableData = JSON.parse(res.data.ReturnJson).ReceiverInfo;
          this.AllCount = JSON.parse(res.data.ReturnJson).AllCount;
        }
      });
    },

    // 添加申报人
    add() {
      this.showModal = true;
    },
    addSave(formValidate) {
      this.$refs[formValidate].validate((valid) => {
        if (valid) {
          let JsonData = {
            UserId: localStorage.getItem("userID"),
            Tel: this.formItem.Tel,
            RName: this.formItem.RName,
            RIDNumber: this.formItem.RIDNumber,
          };
          this.$post("/AddReciver", JsonData).then((res) => {
            if (res.data.State) {
              this.$Message.success("添加申報人成功");
              this.formItem = {}
              this.getDeclarantList();
              this.showModal = false;
            } else {
              this.$Message.error(res.data.MsgText);
            }
          });
        } else {
          this.$Message.error("請填寫完整信息");
        }
      });
    },


    // 删除申报人
    remove(row) {
      this.$Modal.confirm({
        title: "提示",
        content: `確定要刪除此申报人信息嗎？`,
        onOk: () => {
          this.del(row);
        },
        onCancel: () => {
          this.$Message.info("取消操作");
        },
      });
    },
    del(row) {
      let params = {
        ID: row.row.ID,
        MemberId: localStorage.getItem("userID"),
      }
      this.$post('/DeleteReciver',params).then((res) => {
        if(res.data.State) {
          this.$Message.success("已刪除此申報人");
          this.getDeclarantList();
        } else {
          this.$Message.error(res.data.MsgText);
        }
      })
    },
    closeEdit() {
      this.showModal = false;
    },
  },

  computed: {
    columns() {
      return [
        {
          width: 80,
          type: "index",
          title: this.$t("Declarant.no"),
          align: "center",
        },
        {
          key: "RName",
          title: this.$t("Declarant.name"),
          align: "center",
        },
        {
          title: this.$t("Declarant.phone"),
          key: "Tel",
          align: "center",
        },
        {
          title: this.$t("Declarant.number"),
          key: "RIDNumber",
          align: "center",
        },
        {
          title: this.$t("Declarant.createTime"),
          key: "GetTime",
          align: "center",
        },
        {
          title: this.$t("Declarant.operation"),
          fixed: "right",
          align: "center",
          width: 120,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  //   这是点击事件
                  on: {
                    click: () => {
                      this.remove(params);
                    },
                  },
                },
                this.$t("Declarant.delete")
              ),
            ]);
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 1069px;
  background: #fff;
  border-radius: 5px;
  padding: 19px 17px;
}

/deep/ .unify-title {
  display: inline-block;
}

.goods {
  padding: 0 30px;
  height: 30px;
  border-radius: 5px;
  text-align: center;
  @include backgroundColor($_color);
  display: inline-block;
  color: #fff;
  font-size: 16px;
  line-height: 32px;
  margin: 0px 0 0 36px;
  cursor: pointer;
}

#Tbaleone {
  margin: 10px 0;
}

/deep/.ivu-form .ivu-form-item-content .ivu-input-inner-container .ivu-input {
  width: 240px;
}

/deep/ .modal-bag .modal-content {
  height: 56vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/view/user/declarant.vue